import { computed, DestroyRef, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { INavigationTree } from '@navigation';
import { filter, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationMenuService {
  destroyRef = inject(DestroyRef);
  router = inject(Router);

  activeTreeItem = signal<INavigationTree | null>(null);
  selectedCategoryId = computed(() => this.activeTreeItem()?.id);
  selectedCategoryId$ = toObservable(this.selectedCategoryId);

  private closeEventSubject = new Subject();
  closeEvent$ = this.closeEventSubject.asObservable();

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.dropActiveItem());
  }

  public dropActiveItem(): void {
    return this.activeTreeItem.set(null);
  }

  public emitCloseEvent(): void {
    this.closeEventSubject.next(true);
  }
}
